import * as fabric from 'fabric';

let baseRackLabelAttributes = {
    fill: '#FFF',
    fontSize: 14,
    hasRotatingPoint: false,
    selectable: false,
    hasControls: false,
    lockScalingFlip: true,
    lockScalingX: true,
    lockScalingY: true,
};

let baseTextAttributes = {
    entityId: null,
    fontFamily: "",
    fontSize: 0,
    fill: "",
    left: 0,
    top: 0,
    hasRotatingPoint: false,
    selectable: true,
    hasControls: true,
    lockScalingFlip: true,
    lockScalingX: true,
    lockScalingY: true,
    isRack: false,
    isAdditional: true,
};

export const initialCursorPos = { startX : 0, startY : 0, endX : 0, endY : 0 };

export function getSelectionAssignedRacks({canvas, cursorPos}) {
    const tolerance = 3;
    let selectedRackIdMap = new Map();
    //let selectedRackIdList = [];

    canvas.getObjects().map((d) => {
        if (d.left >= (cursorPos.startX - tolerance) && d.left <= cursorPos.endX && d.top >= (cursorPos.startY - tolerance) && d.top <= cursorPos.endY) {                 
             if (d.RackId !== null && d.RackId !== '' && !selectedRackIdMap.has(d.key)) {
                 selectedRackIdMap.set(d.key, d.key);                 
             }
        }
    });

    return selectedRackIdMap;
}


export function populateBody(layoutId, canvas){
    var body = { LayoutId: layoutId, LayoutRackData: [] as any, LayoutAdditional: [] as any };

    canvas.getObjects().map((e) => {
        let baseData =
        {
            Id: e.entityId ?? 0,
            LayoutId: layoutId,
            X: parseInt(e.left),
            Y: parseInt(e.top)
        };

        if (baseData.Id !== undefined) {
            if (e.isRack && baseData.Id != null) {
                baseData.X = e.x;
                baseData.Y = e.y;

                var rackData = {
                    RackId: e.RackId,
                    RackName: e.RackName,
                    RackTypeId: e.RackTypeId,
                    Color: e.RackTypeId !== null ? e.fill : null,
                    Notes: e.Notes,
                    IsDeleted: e.isDisabled,
                    IsUsed: e.IsUsed,
                    RackCategoryListId: e.RackCategoryListId
                }

                rackData = Object.assign(baseData, rackData);
                body.LayoutRackData.push(rackData);
            }
            else if (!e.isRack && e.isAdditional) {
                var additionalData = {                        
                    Description: e.text,
                    Color: e.fill,
                    FontSize: parseInt(e.fontSize),
                    FontFamily: e.fontFamily,
                    Angle: parseInt(e.angle),
                }

                additionalData = Object.assign(baseData, additionalData);
                body.LayoutAdditional.push(additionalData);
            }
        }
    });

    return body;
}

export function drawText(canvas, inputData) {
    let attr = Object.assign(baseTextAttributes, inputData);
    let fabricText = new fabric.FabricText(inputData.inputLabel, attr);
    canvas.add(fabricText);
}

export function renderMappingLayout(canvas, objectData, rackTypeDict) {
    let rackMapByKey = new Map();
    if (objectData.RackData != null && objectData.RackData != undefined && objectData.RackData.length > 0) {
        Object.values(objectData.RackData).forEach(attr => {            
            rackMapByKey.set(attr.key, attr);
            attr.fill = attr.isDisabled ? attr.fill : rackTypeDict[attr.RackTypeId];
            attr.OriginalColor = attr.fill;
            attr.OriginalOpacity = attr.opacity;

            var rect = new fabric.Rect(attr);            
            canvas.add(rect);

            //always render label due to skip call drawRackLabel on assign rack id
            drawRackLabel(canvas, attr);            
        });
    }

    if (objectData.TextData != null && objectData.TextData != undefined && objectData.TextData.length > 0) {
        Object.values(objectData.TextData).forEach(attr => {
            var fabricText = new fabric.FabricText(attr.text, attr);            
            canvas.add(fabricText);
        });
    }

    return rackMapByKey;
}

export function drawRackLabel(canvas, target) {
    var rackTextAttributes = {
        Notes: target.Notes,
        RackCategoryListName: target.RackCategoryListName,
        RackId: target.RackId,
        RackName: target.RackName,
        RackTypeId: target.RackTypeId,
        RackCategoryListId: target.RackCategoryListId,
        IsUsed: target.IsUsed,
        isDisabled: target.isDisabled,
        refId: target.entityId,
        left: target.left + 7,
        top: target.top + 5,
        isRackLabel: true,
        actualLeft: target.left,
        actualTop: target.top,
        key: target.key,
        isAdditional: false,
    };

    rackTextAttributes = Object.assign(baseRackLabelAttributes, rackTextAttributes)

    canvas.add(new fabric.FabricText(target.RackId, rackTextAttributes));
}

export function checkRackIdExists(rackIdDict, selectedRack) {      
    let rack = [...rackIdDict].filter(d => d.RackId == selectedRack.RackId && d.entityId !== selectedRack.entityId);
    return rack.length;
}